import { Box, InfoIcon, Text } from '@wix/design-system';
import React, { useContext } from 'react';
import { RicosContext, ZIndexContext } from 'ricos-context';
import type { HTMLData } from 'ricos-schema';

import { HtmlInputArea } from './HtmlInputArea';

export type AdsenseSourceInputProps = {
  componentData: HTMLData;
  updateComponentData: (value: HTMLData) => void;
};

export const AdsenseSourceInput: React.FC<AdsenseSourceInputProps> = ({
  componentData,
  updateComponentData,
}) => {
  const { t } = useContext(RicosContext);
  const zIndexService = useContext(ZIndexContext);

  return (
    <>
      <Box verticalAlign="middle" gap="SP1">
        <Text size="small">{t('HtmlEditPanel_HtmlInput_AdSense_Title')} </Text>
        <InfoIcon
          size="small"
          content={t('HtmlEditPanel_HtmlInput_AdSense_Tooltip')}
          tooltipProps={{
            appendTo: el => Boolean(el.getAttribute('data-hook')?.includes('ricos-portal')),
            zIndex: zIndexService.getZIndex('TOOLTIP'),
          }}
        />
      </Box>
      <HtmlInputArea
        componentData={componentData}
        onChange={updateComponentData}
        placeholder={t('HtmlEditPanel_HtmlInput_AdSense_Placeholder')}
      />
    </>
  );
};
